import {Injectable} from '@angular/core';
import {MatDateFormats} from '@angular/material';

@Injectable()
export class DatefieldService {

  static MY_FORMATS: MatDateFormats = {
    parse: {
      dateInput: 'DD.MM.YYYY'
    },
    display: {
      dateInput: 'DD.MM.YYYY',
      monthYearLabel: { year: 'numeric', month: 'numeric' },
      dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
      monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
  };

  getDateFormat() {
    return DatefieldService.MY_FORMATS;
  }
}
